import React, {useEffect} from 'react';
import {Table, Button} from 'antd';
import history from "../../../libs/history";
import styles from './layout.module.less'

import store from "./store";
import {observer} from 'mobx-react';

import Search from "./Search";

// the hook
import {useTranslation} from 'react-i18next';
import {toJS} from "mobx";
import projectStore from "../project/store";

export default observer(function () {
  const {t, i18n} = useTranslation()
  const {filterOrders} = store

  useEffect(() => {
    store.fetchOrders()
    projectStore.fetchRecords()
  }, [])

  const columns = [
    {
      title: t('品牌'),
      dataIndex: 'brand',
      align: 'center',
      fixed: true,
      width: 90,
    },
    {
      title: t('产品品名'),
      dataIndex: 'name',
      align: 'center',
      fixed: true,
      width: 150,
    },
    {
      title: t('货号'),
      dataIndex: 'factory_code',
      align: 'center',
      fixed: true,
      width: 100,
    },
    {
      title: t('规格'),
      dataIndex: 'formats',
      align: 'center',
      fixed: true,
      width: 60,
    },
    {
      title: t('单价'),
      dataIndex: 'price',
      align: 'center',
      fixed: true,
      render: (val, record) => <div>{val ? val + (record.type * 1 === 2 ? '元/月' : '元') : '-'}</div>,
    },
    {
      title: t('租期'),
      dataIndex: 'duration',
      align: 'center',
      fixed: true,
      render: val => <div>{val ? val + '月' : '-'}</div>,
    },
    // {
    //   title: t('数量'),
    //   dataIndex: 'number',
    //   key: 'num',
    //   align: 'center',
    //   fixed: true,
    //   render: (val, record) => <div style={{color: '#656565'}}>
    //     <span style={record['deliver_number'] < val ? {color: 'red'} : {}}>{record['deliver_number']}</span>/{val}
    //   </div>,
    // },
    {
      title: t('合计'),
      dataIndex: 'total_price',
      align: 'center',
      fixed: true,
      render: val => <div>{val}元</div>,
    },
    {
      title: t('项目编号'),
      dataIndex: 'extra_sn',
      width: 100,
      align: 'center',
      fixed: true,
      render:  (val, record, index) => {
        let project=projectStore.records.filter(v=>v.id===val*1)
        let txt='-'
        if(project.length){
          txt=project[0]['sn']
        }
        return <div>{txt}</div>
      },
    },
    {
      title: t('预计到货'),
      dataIndex: 'period',
      width: 70,
      align: 'center',
      fixed: true,
      render: val => <div>{val ? val : '-'}</div>,
    },
    {
      title: t('订单状态'),
      dataIndex: 'status_alias',
      width: 80,
      align: 'center',
      fixed: true,
      render: (text, record, index) => {
        if (text === '待通知发货' || text === '部分已通知') {
          return (
            <div>
              <div>{t(text)}</div>
              <Button size="small" type="primary" onClick={() => {
                handleSend(record, index)
              }}>{t('通知发货')}</Button>
            </div>
          )
        } else {
          return (
            <div>
              <div>{t(text)}</div>
              <Button size="small" type="link" onClick={() => {
                watchSendState(record, index)
              }}>{t('查看物流')}</Button>
            </div>
          )
        }


      },
    },
  ]

  const handleSend = (record, index) => {
    store.goods = record
    store.orderIndex = record.index
    history.push('/user/order/send')
  }

  const watchSendState = (record, index) => {
    store.goods = record
    store.orderIndex = record.index
    history.push('/user/order/logistics')
  }

  const makeRowClassName = (record) => {
    return record.disabled ? styles.disabled : ''
  }

  return (
    <React.Fragment>
      <div className={[styles.cart, 'rest-nav1'].join(" ")}>

        <Search/>

        <div className="mainBox">

          {
            filterOrders && filterOrders.map((item, index) => {
              let goods = toJS(item.goods)
              goods.map(v => v.index = index)

              return (
                <div key={item.id + '-' + index}>
                  <div className={styles.innerTitle}>
                    <div>{t('订单编号')}：{item.sn}</div>
                    {/*  <div className={[styles.badge, styles.badgeGhost].join(" ")}>代</div>*/}
                    <div
                      className={[styles.badge, i18n.language === 'en' ? styles.autoWidth : ''].join(' ')}> {t(item.catalog_alias.charAt(0)==='销'?'购':item.catalog_alias.charAt(0))}</div>
                    <div hidden={!item['po_sn']} style={{marginLeft: "0.1979rem"}}>{t('PO号')}：{item['po_sn']}</div>
                    <div style={{flex: 1, marginLeft: "0.1979rem"}}>{t('报价单总金额')}：
                      <b style={{color: '#cc0000'}}>￥{item['total_price'].toFixed(2)}</b>
                    </div>
                    <div>{t('报价时间')}： {item.created_at}</div>
                  </div>
                  <Table className={styles.table}
                         pagination={false}
                         rowClassName={makeRowClassName}
                         rowKey={item => item.id + '-' + item.type}
                         dataSource={goods}
                         columns={columns}/>
                </div>
              )
            })
          }

          <div
            style={{
              textAlign: 'right',
              margin: '0.5208rem 0.026rem 0.2083rem',
              fontSize: "0.0625rem"
            }}>{t('总计')} {filterOrders && filterOrders.length} {t('个记录')}
          </div>

        </div>


      </div>
    </React.Fragment>
  )
})
